import dayjs from 'dayjs';

export const parseDurationIntoHourString = (value: string): string =>
    dayjs.duration(value).asHours().toFixed(1);
